import { render, staticRenderFns } from "./DictionaryAdd.vue?vue&type=template&id=4d62f050&scoped=true&"
import script from "./DictionaryAdd.vue?vue&type=script&lang=js&"
export * from "./DictionaryAdd.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAdd.vue?vue&type=style&index=0&id=4d62f050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62f050",
  null
  
)

export default component.exports